<script setup lang="ts">
import { onBeforeMount, computed } from "vue";
import dayjs from "dayjs";
const dashboardState = useDashboardStore().dashboardState;
import DashboardCardDO = App.Data.DashboardCardDO;
import { useDashboardStore } from "@/modules/dashboards/store";
import { activeFiltersDisplay } from "@/Utils/FilterUtils";
import { useI18n } from "vue-i18n";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import { useRoute } from "vue-router";

const { t } = useI18n();
const route = useRoute();

const props = defineProps<{
	card: DashboardCardDO;
}>();

const parsedText = computed(() => replacePlaceholders(props.card.html_content));

const replacePlaceholders = (html_content) => {
	if (!html_content) return "";

	const replacements = {
		"{period_from}": formatDateWithTime(
			dashboardState.dashboard.period_from_parsed
		),
		"{period_to}": formatDateWithTime(
			dashboardState.dashboard.period_to_parsed
		),
		"{dashboard_filters}": formatActiveFilters(),
		"{dashboard_recipients}":
			route.query.recipients ||
			"<strong>[ Recipients rendered here when exported ]</strong>",
		"{ai_rapport}":
			route.query.ai_rapport ||
			"<strong>[ Ai Rapport rendered here when exported ]</strong>",
	};

	return Object.keys(replacements).reduce(
		(content, key) => content.replaceAll(key, replacements[key]),
		html_content
	);
};

const formatDateWithTime = (dateString) => {
	const date = dayjs(dateString);

	const time = date.format("HH:mm:ss");
	const hasTime = !["00:00:00", "23:59:59"].includes(time);

	return hasTime
		? date.format("dddd D MMMM, HH:mm")
		: date.format("dddd D MMMM");
};

const formatActiveFilters = () => {
	return dashboardState.dashboard.active_filters
		.map((active_filter) => {
			if (active_filter.isApplied) {
				return `<strong>${t(
					`properties.${active_filter.dimension.name_clean}.title`
				)}</strong> is ${activeFiltersDisplay(active_filter)}`;
			}
		})
		.filter(Boolean)
		.join(", ");
};

const emit = defineEmits(["update:isLoading"]);

onBeforeMount(() => {
	setTimeout(() => {
		emit("update:isLoading", false);
	}, 200);
});
</script>

<template>
	<div
		class="w-100 ql-container ql-snow no-border"
		style="white-space: pre-wrap; word-break: break-word"
		v-html="parsedText"
	></div>
</template>

<style scoped lang="scss">
.no-border {
	border: unset !important;
}
</style>
